export default __webpack_public_path__ + "static/media/wheel.4843c1fb.svg";